import React, { useEffect, useState } from 'react'
import utils from '../../utils'
import adminServices from '../../services/AdminServices'
import { IoPersonAdd } from 'react-icons/io5'
import { RiAdminFill } from 'react-icons/ri'
import { FaStoreAlt, FaUser } from 'react-icons/fa'

function UserStats() {
    const [stats, setStats] = useState()

    useEffect(() => {
        getUserStats()
    }, [])

    const getUserStats = () => {
        adminServices.adminUserStats().then(
            res => {
                setStats(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Total Users</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.users_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><IoPersonAdd className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Buyers</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.buyer_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><FaUser className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Vendors</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.vendor_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaStoreAlt className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Staff</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.staff_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><RiAdminFill className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserStats